import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {getSiteName} from '../../../../selectors/system';
import TripBoardButton from '@homeaway/react-trip-board-button';
import withAbacus from '../../../../abacus/with-abacus/with-abacus';

import './TripboardButtonContainer.less';

function mapStateToProps(state) {
    return {
        position: 'right-auto',
        siteName: getSiteName(state)
    };
}

export function TripboardButtonContainer({onClick, ...rest}) {
    /* eslint-disable jsx-a11y/interactive-supports-focus */
    return (
        <div className="tripboard-button-wrapper" onClick={onClick} onKeyPress={onClick} role="button">
            <TripBoardButton {...rest} />
        </div>
    );
}

TripboardButtonContainer.defaultProps = {
    onClick(e) {
        e.preventDefault();
        e.stopPropagation();
    }
};

export default compose(withAbacus, connect(mapStateToProps))(TripboardButtonContainer);



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/TripboardButtonContainer/TripboardButtonContainer.js